export default __webpack_public_path__ + "static/media/logo-black.04122318.png";